import styled from 'styled-components';
import { InputNumber } from 'antd';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	border: 1px solid #d9d9d9;
	border-radius: 6px;
	overflow: hidden;
	height: 40px;
	width: 100%;

	&:focus-within {
		border-color: #2f54eb;
		box-shadow: 0 0 0 2px rgba(74, 108, 247, 0.2);
	}
`;

export const ValueInput = styled(InputNumber)`
	border: none !important;
	box-shadow: none !important;
	width: 60%;

	.ant-input-number-input {
		font-size: 16px;
		font-weight: 500;
		padding: 0 10px;
		height: 38px;
	}
`;

export const Button = styled.button`
	width: 20%;
	height: 100%;
	border: none;
	background: rgb(255, 255, 255);
	font-size: 26px;
	font-weight: 500;
	color: rgb(217, 217, 217);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;

	&:hover {
		background: #f5f5f5;
		color: #2f54eb;
	}

	&:not(:last-child) {
		border-right: 1px solid #d9d9d9;
		border-left: 1px solid #d9d9d9;
	}
`;
